import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=1b9c3df5&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=1b9c3df5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c3df5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9c3df5')) {
      api.createRecord('1b9c3df5', component.options)
    } else {
      api.reload('1b9c3df5', component.options)
    }
    module.hot.accept("./noticeList.vue?vue&type=template&id=1b9c3df5&scoped=true", function () {
      api.rerender('1b9c3df5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/noticeManage/noticeList.vue"
export default component.exports